import styled from "styled-components";

//main container set to max-width 500px ta avoida a lot of media quieries and so it's still looks good in all devices.

const MainContainer = styled.main`
  max-width:500px;
  background-color: #fff;
  margin: 50px auto;
  padding-bottom: 20px;
  border-radius: 25px 0 25px 0px;
`;


export default MainContainer;